<div class="app-view-container h-full" [attr.data-test-id]="'assets_container'">
  <div class="main-actions">
    <thehubz-assets-actions
      *ngIf="!dashboardFlag"
      [hideBulkEdit]="hideBulkEdit"
      [filterBubbles]="filterBubbles"
      [projectFlag]="projectFlag"
      [showUploadBtn]="showUploadBtn"
      [configObject]="configObject"
      [bulkEditAccessibility]="bulkEditAccessibility()"
      [assetCount]="assetCount"
      [showEmptyState]="showEmptyState"
      [searchText]="searchText"
      [appliedFilters]="appliedFilters"
      [filterAssetFormData]="filterAssetFormData"
      [selectedFilterObject]="selectedFilterObject"
      [selectedViewType]="selectedViewType"
      [selectedViewSection2]="selectedViewSection2"
      [sortByNew]="sortByNew"
      [gridSettingsKeySuffix]="gridSettingsKeySuffix"
      (uploadClick)="onUploadClick()"
      (selectAll)="selectAll($event)"
      (unselectAll)="assetFindAll()"
      (searchTextChanged)="searchTextChanged($event)"
      (addOnEnter)="addOnEnter()"
      (clearSearch)="clearSearch()"
      (toggleMobileSearch)="toggleMobileSearch()"
      (restFormField)="resetFormField()"
      (viewAssetTags)="viewAssetTags()"
      (applyFilters)="applyFilters($event)"
      (updateFormData)="updateFormData($event)"
      (changeAssetView)="changeAssetView($event)"
      (sortToggle)="sortToggle($event)"
      (editSelectedAsset)="editAssets($event)"
      (toggleSidebar)="toggleSidebar()"
      (showAssetMismatchDialog)="showAssetMismatchDialog()"
      (updateAssetDraft)="onUploadClickDraft($event)"
      [tableData]="tableData"
    ></thehubz-assets-actions>
    <div class="mobile-search" [ngClass]="{ 'is-open': isMobileSearchOpen }">
      <sp-search-field
        [searchText]="searchText"
        [maxWidth]="''"
        (keyUpInput)="searchTextChanged($event)"
        (clearInput)="clearSearch()"
        [placeholder]="searchPlaceholder"
        (addOnEnter)="addOnEnter()"
        [mobileSearch]="true"
      ></sp-search-field>
    </div>
  </div>

  <div *ngFor="let s of sizes" class="invisible {{ s.css + ' ' + (prefix + s.id) }}"></div>
  <!-- To show loading message, while http call is in progress -->
  <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
  <ng-template #loadingComplete>
    <div class="layout-columns flex">
      <div class="aside-column layout-column w-1/4" *ngIf="isAssetSidebarEnabled && assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)">
        <thehubz-assets-sidebar
          id="assets-sidebar"
          [configObject]="configObject"
          [appliedFilters]="appliedFilters"
          [filterAssetFormData]="filterAssetFormData"
          [selectedFilterObject]="selectedFilterObject"
          [formResetter]="formResetter.asObservable()"
          (applyFilters)="applyFilters($event)"
          (updateFormData)="updateFormData($event)"
          (viewAssetTags)="viewAssetTags()"
          [gridSettingsKeySuffix]="gridSettingsKeySuffix"
          (requestClose)="toggleSidebar()"
        ></thehubz-assets-sidebar>
      </div>
      <div
        *ngIf="dashboardFlag || projectFlag ? true : assetViewTypeService.getGridSettings('showGridView', gridSettingsKeySuffix)"
        class="main-column layout-column w-full"
        [ngClass]="showEmptyState ? '!h-1/2' : dashboardFlag ? 'h-full' : 'h-full'"
      >
        <div class="filter-selected-container">
          <div *ngIf="brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge" class="p-2">
            {{ assetCount }}&nbsp;<ng-container i18n>Results</ng-container>
          </div>
          <div *ngIf="showFilterBubbles && filterBubbles.length" class="applied-filter-container">
            <sp-chips-listbox-option
              [dataSource]="filterBubbles"
              [clearAllChip]="true"
              [highlighted]="false"
              [selectable]="false"
              (removeChip)="removeFilterBubble($event)"
              (removeChips)="removeAllFilterBubble()"
            ></sp-chips-listbox-option>
          </div>
        </div>
        <div class="app-content-container">
          <thehubz-asset-gallery-view
            *ngIf="!loading && !showEmptyState"
            [imageObject]="imageObject"
            [imageSplitObject]="imageSplitObject"
            [currentSize]="currentSize"
            [filterObject]="filterObject"
            [configObject]="configObject"
            [assetUploadStepperFlag]="assetUploadStepperFlag"
            [itemSize]="itemSize"
            [assetCount]="assetCount"
            [dashboardFlag]="dashboardFlag"
            [projectFlag]="projectFlag"
            [assetChecked]="assetChecked"
            [enableAssetDetailsLink]="enableAssetDetailsLink"
            (updateSelectedData)="updateSelectedData.emit($event)"
            (selectedAssets)="selectedAssets.emit($event); fileListSelection($event)"
            (deleteAsset)="deleteAsset($event.asset, $event.id, $event.planDeletionFlag)"
            (downloadAsset)="download($event.asset)"
            (addRemoveFromBasket)="addRemoveFromBasket($event)"
            (viewportScrolled)="onAssetScroll($event, 'gallery')"
            (uploadClick)="onUploadClickDraft($event)"
            [offset]="offset"
            (editAssets)="editAssets($event)"
            [gridSettingsKeySuffix]="gridSettingsKeySuffix"
            [size]="size"
          >
          </thehubz-asset-gallery-view>
          <div *ngIf="showEmptyState" [ngClass]="{ '!h-1': configObject?.callFrom === 'createProject', 'mt-0': configObject?.callFrom !== 'createProject' }" class="ml-3 pr-3 overflow-hidden">
            <sp-blank-page pageType="assets"></sp-blank-page>
          </div>
          <div *ngIf="loading" class="spinner-item">
            <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
          </div>
        </div>
      </div>
      <div
        *ngIf="dashboardFlag || projectFlag ? false : assetViewTypeService.getGridSettings('showListView', gridSettingsKeySuffix)"
        class="main-column layout-column w-full"
        [ngClass]="showEmptyState ? '!h-20' : 'h-full'"
      >
        <div class="filter-selected-container flex">
          <div *ngIf="brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge" class="p-2" i18n>{{ assetCount }} Results</div>
          <div *ngIf="showFilterBubbles && filterBubbles.length" class="flex-auto">
            <sp-chips-listbox-option
              [dataSource]="filterBubbles"
              [clearAllChip]="true"
              [highlighted]="false"
              [selectable]="false"
              (removeChip)="removeFilterBubble($event)"
              (removeChips)="removeAllFilterBubble()"
            ></sp-chips-listbox-option>
          </div>
        </div>
        <div class="app-content-container">
          <thehubz-asset-listview
            *ngIf="!loading && !showEmptyState"
            [configObject]="configObject"
            (deleteAsset)="deleteAsset($event.asset, $event.id, $event.planDeletionFlag)"
            (downloadAsset)="download($event.asset)"
            [assetData]="imageObject"
            [filterObject]="filterObject"
            [tableColumnData]="tableColumnData"
            [assetCount]="assetCount"
            [dashboardFlag]="dashboardFlag"
            [projectFlag]="projectFlag"
            (changeView)="changeAssetView($event)"
            (uploadClick)="onUploadClickDraft($event)"
            (updateSelectedData)="updateSelectedData.emit($event); selectedAssets.emit($event)"
            (sortBy)="sortToggle()"
            (clickSortFilter)="sortAssets($event)"
            (tableScrolled)="onAssetScroll($event, 'list')"
            (editAssets)="editAssets($event)"
            (addRemoveFromBasket)="addRemoveFromBasket($event, $event.checked)"
            [loading]="loading"
            [offset]="offset"
            [gridSettingsKeySuffix]="gridSettingsKeySuffix"
            [assetUploadStepperFlag]="assetUploadStepperFlag"
            (tableData)="tableData = $event"
          >
          </thehubz-asset-listview>
          <div *ngIf="showEmptyState" [ngClass]="{ '!h-1': configObject?.callFrom === 'createProject', 'mt-0': configObject?.callFrom !== 'createProject' }" class="ml-3 pr-3 overflow-hidden">
            <sp-blank-page pageType="assets"></sp-blank-page>
          </div>
          <div *ngIf="loading" class="spinner-item">
            <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
